import _Dialog from './dialog';
import _DialogCard from './dialog-card';
import { withInstall } from '@tdesign/shared-utils';
import { TdDialogProps } from './type';

import './style';

export * from './type';
export type DialogProps = TdDialogProps;

export const Dialog = withInstall(_Dialog);
export const DialogCard = withInstall(_DialogCard);

export { default as DialogPlugin } from './plugin';
export type { DialogPluginType } from './plugin';
export default Dialog;
